module.exports = __webpack_public_path__ + "static/brushStrokeSmall50-21a2ad27c8b0ecae980d6df4f67be0e7.png";